var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21717 7.8541H7.88142C6.76279 7.8541 6.20371 7.8541 5.75007 8.0576C5.35019 8.23699 5.00952 8.5259 4.76684 8.89085C4.49152 9.30486 4.39897 9.8564 4.21506 10.9598L3.13098 17.4643L3.13054 17.4667C2.88263 18.9542 2.7586 19.6984 2.974 20.2783C3.16312 20.7875 3.5253 21.2142 3.99645 21.4844C4.53334 21.7924 5.28754 21.7924 6.79703 21.7924H18.9292C20.4387 21.7924 21.1941 21.7924 21.731 21.4844C22.2022 21.2142 22.5635 20.7875 22.7526 20.2783C22.9679 19.6986 22.8439 18.9548 22.5962 17.4685L22.5953 17.4643L21.5112 10.9598C21.3273 9.85641 21.2352 9.30486 20.9599 8.89085C20.7172 8.5259 20.3763 8.23699 19.9764 8.0576C19.5228 7.8541 18.964 7.8541 17.8454 7.8541H17.5094M8.21717 7.8541H17.5094M8.21717 7.8541C8.21717 5.28813 10.2973 3.20801 12.8633 3.20801C15.4292 3.20801 17.5094 5.28813 17.5094 7.8541",
    stroke: "#2B48AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.886f2032f6564ca9a8fadad77a7c98ae.svg";
export { ForwardRef as ReactComponent };